import { Directive, input } from '@angular/core'

import { Section } from 'app/core/cms/type-unions'

import { DynamicInsert } from './dynamic-insert'
import { SECTION_MAPPING } from './sections/section-mapping.const'

@Directive({ selector: 'ng-template[paiInsertDynamicSection]', standalone: true })
export class InsertDynamicSectionDirective extends DynamicInsert<typeof SECTION_MAPPING> {
  readonly data = input.required<Section>({ alias: 'paiInsertDynamicSection' })
  protected readonly blockMapping = SECTION_MAPPING
}
